import {
  Backdrop,
  CircularProgress,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import React, { PropsWithChildren, useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { LOCAL_STORAGE_KEY, THEME_TYPE } from "../common/const";
import { ShowProgress } from "../state/ShowProgress";
import { ThemeLight } from "../state/ThemeLight";

export const WrappedLayout: React.FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const [showProgress] = useRecoilState(ShowProgress);
  const [themeLight, setThemeLight] = useRecoilState(ThemeLight);

  const [theme, setTheme] = useState(
    createTheme({
      palette: {
        mode: "light",
      },
    })
  );

  useEffect(() => {
    const theme = localStorage.getItem(LOCAL_STORAGE_KEY.THEME);

    if (theme === THEME_TYPE.DARK) {
      setThemeLight(false);
    } else {
      setThemeLight(true);
    }
  }, []);

  useEffect(() => {
    const htmlElement = document.documentElement;
    if (themeLight) {
      localStorage.setItem(LOCAL_STORAGE_KEY.THEME, THEME_TYPE.LIGHT);
      htmlElement.setAttribute("data-bs-theme", THEME_TYPE.LIGHT);
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY.THEME, THEME_TYPE.DARK);
      htmlElement.setAttribute("data-bs-theme", THEME_TYPE.DARK);
    }

    setTheme(
      createTheme({
        palette: {
          mode: themeLight ? "light" : "dark",
        },
      })
    );
  }, [themeLight]);

  return (
    <>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
      {/* {children} */}
      <Backdrop sx={{ color: "#fff", zIndex: 10000 }} open={showProgress}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
